import { stringify } from 'qs';
import request from '../request'
import { url } from '../service-utils';

// 获取指标统计列表
export async function getNormList(params) {
  return request(`${url.activitySign}/activity/item/item-list?${stringify(params)}`)
}

// 获取指标统计详情的接口
export async function getNormDetail(params) {
  return request(`${url.activitySign}/activity/item/item-detail?${stringify(params)}`)
}

// 获取指标明细详情的接口
export async function getIndexDetail(params) {
  return request(`${url.activitySign}/activity/item/person-item?${stringify(params)}`)
}

// 获取指标的列表
export async function getIndexList(params) {
	const { activityBizId } = params
  return request(`${url.activitySign}/activity/item/item-name/${activityBizId}`)
}